import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { MdArrowBackIosNew } from "react-icons/md";
import FullTimeTable from "./FullTimeTable";
import { allColumns } from "./Columns";

import './TimeTable.css';

const MonthlyTimeTable = ({ month, title, columnKey = "12Columns", districtDetails  }) => {
  const [filtertimes, setFilterTimes] = useState([]);
  const currentYear = new Date().getFullYear(); 
  const { district, state } = districtDetails;


  useEffect(() => {
    if (!districtDetails) return;

    // Fetch data based on the district
    const districtData = FullTimeTable[districtDetails.district] || [];

    const transformedData = districtData
      .map((item) => ({
        ...item,
        date: `${item.date}-${currentYear}`,
      }))
      .filter(item => {
        const dateParts = item.date.split('-'); 
        const day = parseInt(dateParts[0], 10); 
        const itemMonth = dateParts[1];
  
        return itemMonth === String(month) && day >= 1 && day <= 31;
      });

    setFilterTimes(transformedData);
  }, [currentYear, month, districtDetails]); 

  // Dynamically select columns based on the key
  const tableColumns = allColumns[columnKey] || allColumns["12Columns"];

const formatDate = (date) => {
  const d = date.getDate();        // no padStart
  const m = date.getMonth() + 1;   // no padStart
  const y = date.getFullYear();
  const formattedDate = `${d}-${m}-${y}`;
  return formattedDate;
};


const conditionalRowStyles = [
  {
    when: row => {
      return row.date === formatDate(new Date());
    },
    style: {
      backgroundColor: '#e9f5ff !important',
      fontWeight: 'bold',
      color: '#333',
    },
  },
];


  return (
    <div className='contain'>
      <div className="page-header">
        <span className="backBtn" onClick={() => window.history.back()}>
          <MdArrowBackIosNew />
        </span>
        <div className="page-header__content">
          <h1 className="pagetitle">{title}</h1>
         <p>{district}{state ? `, ${state}` : ''}, India</p>   

        </div>
      </div>
      <div className="contentSection-card timeTable ">
        <DataTable 
          columns={tableColumns} 
          data={filtertimes} 
          fixedHeader
          fixedHeaderScrollHeight='460px'
          selectableRowsHighlight  
          highlightOnHover
          conditionalRowStyles={conditionalRowStyles}
        />
      </div>
    </div>
  );
};

export default MonthlyTimeTable;
